<template>
  <iframe
    title="web-output"
    width="100%"
    height="100%"
    frameborder="0"
    :srcdoc="$store.state.srcDoc"
    sandbox="allow-scripts"
  />
</template>

<script>
export default {
  name: "web-output"
};
</script>